import { DesignVersionProvider, ParticleDesignVersions } from '@klarna/bubble-ui'

import React, { ReactElement, useContext } from 'react'

import PropTypes from 'prop-types'

export const DarkModeContext = React.createContext(false)

interface DarkModeProviderProps {
  dark: boolean
  children: React.ReactNode
}
export const DarkModeProvider = ({ dark, children }: DarkModeProviderProps) => (
  <DarkModeContext.Provider value={dark}>{children}</DarkModeContext.Provider>
)

interface DesignProviderProps {
  dark: boolean
  children: ReactElement<any>
}

export const DesignProvider = ({ children, dark }: DesignProviderProps) => (
  <DarkModeProvider dark={dark}>
    <DesignVersionProvider
      value={dark ? ParticleDesignVersions.PANCAKE_DARK : ParticleDesignVersions.PANCAKE_LIGHT}
    >
      {children}
    </DesignVersionProvider>
  </DarkModeProvider>
)

DesignProvider.propTypes = {
  dark: PropTypes.bool.isRequired,
  children: PropTypes.any
}

export function useDarkModeContext() {
  return useContext(DarkModeContext)
}
